import React from "react";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export default function FormActions({
  onCancel,
  saveDisabled,
  children,
  showCancel = true,
  showSave = true,
  saveText,
  saveIconProps,
  className,
}: {
  onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  saveDisabled?: boolean;
  children?: React.ReactNode;
  showCancel?: boolean;
  showSave?: boolean;
  saveText?: string;
  saveIconProps?: FontAwesomeIconProps;
  className?: string;
}) {
  return (
    <div className={`tixxt__form--actions ${className || ""}`}>
      {showCancel && (
        <button
          type="reset"
          onClick={(e) => {
            onCancel ? onCancel(e) : window.history.back();
          }}
          className="btn btn-light"
        >
          {I18n.t("js.cancel")}
        </button>
      )}
      {showSave && (
        <button
          type="submit"
          className="btn btn-primary flex gap-1 items-center justify-center"
          disabled={saveDisabled}
        >
          {saveIconProps && <FontAwesomeIcon {...saveIconProps} />}
          {saveText || I18n.t("js.save")}
        </button>
      )}
      {children}
    </div>
  );
}
